const ORBS = [
  { top: '8%', left: '-12%', size: 560, color: 'rgba(180,255,0,0.20)' },
  { top: '35%', right: '-14%', size: 600, color: 'rgba(56,189,248,0.18)', delay: '-6s' },
  { bottom: '-12%', left: '18%', size: 540, color: 'rgba(224,122,95,0.18)', delay: '-11s' },
  { bottom: '10%', right: '8%', size: 420, color: 'rgba(180,255,0,0.14)', delay: '-3s' },
];

// Sfere di colore sfocate fisse dietro a tutte le pagine: danno profondità al vetro.
export function GlassAmbient() {
  return (
    <div aria-hidden className="fixed inset-0 -z-10 overflow-hidden pointer-events-none" data-testid="glass-ambient">
      {ORBS.map((o, i) => (
        <div key={i} className="glass-orb" style={{
          top: o.top, bottom: o.bottom, left: o.left, right: o.right, width: o.size, height: o.size,
          background: `radial-gradient(circle, ${o.color}, transparent 70%)`, animationDelay: o.delay,
        }}/>
      ))}
    </div>
  );
}
